import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaCog,
  FaUser
} from 'react-icons/fa';

// Import components
import ProfilePage from '../Profil/ProfilePage';

const SettingsModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'settings',
    title: t('modules.settings.title'),
    description: t('modules.settings.description'),
    icon: FaCog,
    color: '#6c757d',
    menuItems: [
      { path: '/settings-module/profile', icon: FaUser, label: t('nav.profile') }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/settings-module/profile" replace />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Routes>
    </ModuleLayout>
  );
};

export default SettingsModule;
